import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "light", setTheme: () => {}, toggle: () => {} });

export function ThemeProvider({ children }) {
    const [theme, setThemeState] = useState(() => {
        if (typeof window === "undefined") return "light";
        return localStorage.getItem("hrm-theme") || (window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light");
    });

    useEffect(() => {
        const root = document.documentElement;
        if (theme === "dark") root.classList.add("dark");
        else root.classList.remove("dark");
        localStorage.setItem("hrm-theme", theme);
    }, [theme]);

    const setTheme = (t) => setThemeState(t === "dark" ? "dark" : "light");
    const toggle = () => setThemeState((p) => (p === "dark" ? "light" : "dark"));

    return (
        <ThemeContext.Provider value={{ theme, setTheme, toggle }}>
            {children}
        </ThemeContext.Provider>
    );
}

export const useTheme = () => useContext(ThemeContext);
